import MaxValidator from './MaxValidator';

export class LessValidator extends MaxValidator {
    static key = 'less';
}

export default LessValidator;
